import * as React from 'react';

import * as styles from './index.css';

export const WarningInfoLink = () => (
  <a className={styles['warning_info_link']} href="/help/quality/37645/" target="_blank">
    Подробнее
  </a>
);
